import { BOOKENDS_SWAN_STYLES } from "@vp/esi-bookends"
import { getRootClassNames, SwanHead, SwanProvider, SWAN_STYLE_KEY_MAP, useBrowserClasses } from "@vp/swan"
import { Link } from "gatsby"
import * as React from "react"
import { Helmet } from "react-helmet"

const styleKeys = [...BOOKENDS_SWAN_STYLES, SWAN_STYLE_KEY_MAP.popover, SWAN_STYLE_KEY_MAP.table]

export const SwanConfiguration = ({ tenant, locale, children }) => {
  const browserClassName = useBrowserClasses()
  const bodyClassName = getRootClassNames()
  return (
    <SwanProvider swanLocale={locale} swanTenant={tenant} globalLinkComponent={Link}>
      <Helmet htmlAttributes={{ class: browserClassName }} bodyAttributes={{ class: bodyClassName }} />
      <SwanHead renderWith={Helmet} renderStyleContentAsChildren styleSheetKeys={styleKeys} />
      {children}
    </SwanProvider>
  )
}
